import Vue from 'vue/dist/vue.esm';


  
  import BarGraphStatisticAttestation from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/attestation/BarGraphStatisticAttestation.vue";
  Vue.component("bar-graph-statistic-attestation", BarGraphStatisticAttestation);

  
  import CardGraphFacultyStatisticAttestation from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/attestation/CardGraphFacultyStatisticAttestation.vue";
  Vue.component("card-graph-faculty-statistic-attestation", CardGraphFacultyStatisticAttestation);

  
  import CardGraphUniversityStatisticAttestation from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/attestation/CardGraphUniversityStatisticAttestation.vue";
  Vue.component("card-graph-university-statistic-attestation", CardGraphUniversityStatisticAttestation);

  
  import CardStatisticAttestation from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/attestation/CardStatisticAttestation.vue";
  Vue.component("card-statistic-attestation", CardStatisticAttestation);

  
  import TabsStatisticAttestation from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/attestation/TabsStatisticAttestation.vue";
  Vue.component("tabs-statistic-attestation", TabsStatisticAttestation);

  
  import TheCardUniversityStatisticAttestation from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/attestation/TheCardUniversityStatisticAttestation.vue";
  Vue.component("the-card-university-statistic-attestation", TheCardUniversityStatisticAttestation);

  
  import TheEducationAttestation from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/attestation/TheEducationAttestation.vue";
  Vue.component("the-education-attestation", TheEducationAttestation);

  
  import TheEducationAttestationStatisticsTable from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/attestation/TheEducationAttestationStatisticsTable.vue";
  Vue.component("the-education-attestation-statistics-table", TheEducationAttestationStatisticsTable);

  
  import TheEducationalAttestationStatistics from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/attestation/TheEducationalAttestationStatistics.vue";
  Vue.component("the-educational-attestation-statistics", TheEducationalAttestationStatistics);

  
  import TheFacultyStatisticsCard from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/attestation/TheFacultyStatisticsCard.vue";
  Vue.component("the-faculty-statistics-card", TheFacultyStatisticsCard);

  
  import TheFacultyStatisticsTable from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/attestation/TheFacultyStatisticsTable.vue";
  Vue.component("the-faculty-statistics-table", TheFacultyStatisticsTable);

  
  import TheGroupAttestation from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/attestation/TheGroupAttestation.vue";
  Vue.component("the-group-attestation", TheGroupAttestation);

  
  import TheGroupAttestationTable from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/attestation/TheGroupAttestationTable.vue";
  Vue.component("the-group-attestation-table", TheGroupAttestationTable);

  
  import ThePageStatisticAttestationFacultyAndUniversity from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/attestation/ThePageStatisticAttestationFacultyAndUniversity.vue";
  Vue.component("the-page-statistic-attestation-faculty-and-university", ThePageStatisticAttestationFacultyAndUniversity);

  
  import TheValueAttestationStudentTableDiv from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/attestation/TheValueAttestationStudentTableDiv.vue";
  Vue.component("the-value-attestation-student-table-div", TheValueAttestationStudentTableDiv);

  
  import Covid19 from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/covid_19.vue";
  Vue.component("covid-19", Covid19);

  
  import DigitalSignature from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/digital_signature.vue";
  Vue.component("digital-signature", DigitalSignature);

  
  import EffConOrderFormDialog from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/effective_contract/Dialog/EffConOrderFormDialog.vue";
  Vue.component("eff-con-order-form-dialog", EffConOrderFormDialog);

  
  import EffectiveContractAutoCalculationDetailDialog from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/effective_contract/Dialog/EffectiveContractAutoCalculationDetailDialog.vue";
  Vue.component("effective-contract-auto-calculation-detail-dialog", EffectiveContractAutoCalculationDetailDialog);

  
  import PersonEffConDialog from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/effective_contract/Dialog/PersonEffConDialog.vue";
  Vue.component("person-eff-con-dialog", PersonEffConDialog);

  
  import TheEditFactContractDialog from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/effective_contract/Dialog/TheEditFactContractDialog.vue";
  Vue.component("the-edit-fact-contract-dialog", TheEditFactContractDialog);

  
  import TheEditTeacherOrderDialog from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/effective_contract/Dialog/TheEditTeacherOrderDialog.vue";
  Vue.component("the-edit-teacher-order-dialog", TheEditTeacherOrderDialog);

  
  import TheFilterTeachersListDialog from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/effective_contract/Dialog/TheFilterTeachersListDialog.vue";
  Vue.component("the-filter-teachers-list-dialog", TheFilterTeachersListDialog);

  
  import TheShippingAlertDialog from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/effective_contract/Dialog/TheShippingAlertDialog.vue";
  Vue.component("the-shipping-alert-dialog", TheShippingAlertDialog);

  
  import SectionTableUmuCheck from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/effective_contract/SectionTableUmuCheck.vue";
  Vue.component("section-table-umu-check", SectionTableUmuCheck);

  
  import EffectiveContractApp from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/effective_contract/app/EffectiveContractApp.vue";
  Vue.component("effective-contract-app", EffectiveContractApp);

  
  import Layout from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/effective_contract/app/Layout.vue";
  Vue.component("layout", Layout);

  
  import Loading from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/effective_contract/app/Loading.vue";
  Vue.component("loading", Loading);

  
  import EffContractNotificationSnackbar from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/effective_contract/app/components/EffContractNotificationSnackbar.vue";
  Vue.component("eff-contract-notification-snackbar", EffContractNotificationSnackbar);

  
  import EffContractAutoCalculateDetailTable from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/effective_contract/app/components/OrderPage/EffContractAutoCalculateDetailTable.vue";
  Vue.component("eff-contract-auto-calculate-detail-table", EffContractAutoCalculateDetailTable);

  
  import EffectiveContractAccessTable from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/effective_contract/app/components/OrderPage/EffectiveContractAccessTable.vue";
  Vue.component("effective-contract-access-table", EffectiveContractAccessTable);

  
  import EffConTable from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/effective_contract/app/components/TeacherPage/EffConTable.vue";
  Vue.component("eff-con-table", EffConTable);

  
  import EffContractTeacherActionDataCard from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/effective_contract/app/components/TeacherPage/EffContractTeacherActionDataCard.vue";
  Vue.component("eff-contract-teacher-action-data-card", EffContractTeacherActionDataCard);

  
  import EffContractTeacherDataCard from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/effective_contract/app/components/TeacherPage/EffContractTeacherDataCard.vue";
  Vue.component("eff-contract-teacher-data-card", EffContractTeacherDataCard);

  
  import EffContractTeacherDataList from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/effective_contract/app/components/TeacherPage/EffContractTeacherDataList.vue";
  Vue.component("eff-contract-teacher-data-list", EffContractTeacherDataList);

  
  import EffContractTeacherRemarkPopup from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/effective_contract/app/components/TeacherPage/EffContractTeacherRemarkPopup.vue";
  Vue.component("eff-contract-teacher-remark-popup", EffContractTeacherRemarkPopup);

  
  import ErrorMessage from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/effective_contract/app/components/TeacherPage/ErrorMessage.vue";
  Vue.component("error-message", ErrorMessage);

  
  import PathTableEffContract from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/effective_contract/app/components/TeacherPage/PathTableEffContract.vue";
  Vue.component("path-table-eff-contract", PathTableEffContract);

  
  import TheCircleProgressContract from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/effective_contract/app/components/TeacherPage/TheCircleProgressContract.vue";
  Vue.component("the-circle-progress-contract", TheCircleProgressContract);

  
  import TheDecipheringProgressContract from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/effective_contract/app/components/TeacherPage/TheDecipheringProgressContract.vue";
  Vue.component("the-deciphering-progress-contract", TheDecipheringProgressContract);

  
  import TheDropdownListContractError from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/effective_contract/app/components/TeacherPage/TheDropdownListContractError.vue";
  Vue.component("the-dropdown-list-contract-error", TheDropdownListContractError);

  
  import EffContractUmuDetailDialog from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/effective_contract/app/components/UMUPage/EffContractUMUDetailDialog.vue";
  Vue.component("eff-contract-umu-detail-dialog", EffContractUmuDetailDialog);

  
  import EffContractUmuCommentFormDialog from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/effective_contract/app/components/UMUPage/EffContractUmuCommentFormDialog.vue";
  Vue.component("eff-contract-umu-comment-form-dialog", EffContractUmuCommentFormDialog);

  
  import SubTableEffContract from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/effective_contract/app/components/UMUPage/SubTableEffContract.vue";
  Vue.component("sub-table-eff-contract", SubTableEffContract);

  
  import TheEffContractUmuTableColumnFullName from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/effective_contract/app/components/UMUPage/TheEffContractUmuTableColumnFullName.vue";
  Vue.component("the-eff-contract-umu-table-column-full-name", TheEffContractUmuTableColumnFullName);

  
  import TheHeaderTableUmuSection from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/effective_contract/app/components/UMUPage/TheHeaderTableUmuSection.vue";
  Vue.component("the-header-table-umu-section", TheHeaderTableUmuSection);

  
  import EffectiveContractUmuPage from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/effective_contract/app/pages/EffectiveContractUMUPage.vue";
  Vue.component("effective-contract-umu-page", EffectiveContractUmuPage);

  
  import EffectiveContractsOrderFormPage from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/effective_contract/app/pages/EffectiveContractsOrderFormPage.vue";
  Vue.component("effective-contracts-order-form-page", EffectiveContractsOrderFormPage);

  
  import EffectiveContractsTeacherPage from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/effective_contract/app/pages/EffectiveContractsTeacherPage.vue";
  Vue.component("effective-contracts-teacher-page", EffectiveContractsTeacherPage);

  
  import EstudyAgreed from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/estudy/estudy_agreed.vue";
  Vue.component("estudy-agreed", EstudyAgreed);

  
  import EstudyEnroll from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/estudy/estudy_enroll.vue";
  Vue.component("estudy-enroll", EstudyEnroll);

  
  import EstudyIndex from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/estudy/estudy_index.vue";
  Vue.component("estudy-index", EstudyIndex);

  
  import AchievementKindCard from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Admin/Cards/CardAdminAchievement/AchievementKindCard.vue";
  Vue.component("achievement-kind-card", AchievementKindCard);

  
  import HeaderTabAdmin from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Admin/Cards/CardAdminAchievement/HeaderTabAdmin.vue";
  Vue.component("header-tab-admin", HeaderTabAdmin);

  
  import MainCardAdmin from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Admin/Cards/CardAdminAchievement/MainCardAdmin.vue";
  Vue.component("main-card-admin", MainCardAdmin);

  
  import FormTypeAchievement from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Admin/Dialogs/FormTypeAchievement.vue";
  Vue.component("form-type-achievement", FormTypeAchievement);

  
  import TheListsPortfolios from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Admin/Lists/TheListsPortfolios.vue";
  Vue.component("the-lists-portfolios", TheListsPortfolios);

  
  import AchievementsTableAdmin from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Admin/Tables/AchievementsTableAdmin.vue";
  Vue.component("achievements-table-admin", AchievementsTableAdmin);

  
  import AchievementSettingTab from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Admin/Tabs/AchievementSettingTab.vue";
  Vue.component("achievement-setting-tab", AchievementSettingTab);

  
  import ListPortfolios from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Admin/Tabs/ListPortfolios.vue";
  Vue.component("list-portfolios", ListPortfolios);

  
  import UnitsTableCard from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Admin/Tabs/UnitsTableCard.vue";
  Vue.component("units-table-card", UnitsTableCard);

  
  import AddCard from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Cards/AddCard.vue";
  Vue.component("add-card", AddCard);

  
  import TheAchievementNameAndTypeCardArch from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Cards/CardAchievementElements/TheAchievementNameAndTypeCardArch.vue";
  Vue.component("the-achievement-name-and-type-card-arch", TheAchievementNameAndTypeCardArch);

  
  import TheAchievementTypeSelect from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Cards/CardAchievementElements/TheAchievementTypeSelect.vue";
  Vue.component("the-achievement-type-select", TheAchievementTypeSelect);

  
  import TheActionHeaderCardArch from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Cards/CardAchievementElements/TheActionHeaderCardArch.vue";
  Vue.component("the-action-header-card-arch", TheActionHeaderCardArch);

  
  import TheAdditionalInfoCardAch from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Cards/CardAchievementElements/TheAdditionalInfoCardAch.vue";
  Vue.component("the-additional-info-card-ach", TheAdditionalInfoCardAch);

  
  import TheFileSectionCardAch from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Cards/CardAchievementElements/TheFileSectionCardAch.vue";
  Vue.component("the-file-section-card-ach", TheFileSectionCardAch);

  
  import TheUnitSectionCardArch from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Cards/CardAchievementElements/TheUnitSectionCardArch.vue";
  Vue.component("the-unit-section-card-arch", TheUnitSectionCardArch);

  
  import CardAchievements from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Cards/CardAchievements.vue";
  Vue.component("card-achievements", CardAchievements);

  
  import TheActionTitlePortfolio from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Cards/CardTitlePortfolio/TheActionTitlePortfolio.vue";
  Vue.component("the-action-title-portfolio", TheActionTitlePortfolio);

  
  import TheAvatarPortfolio from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Cards/CardTitlePortfolio/TheAvatarPortfolio.vue";
  Vue.component("the-avatar-portfolio", TheAvatarPortfolio);

  
  import TheTabsTitleProfile from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Cards/CardTitlePortfolio/TheTabsTitleProfile.vue";
  Vue.component("the-tabs-title-profile", TheTabsTitleProfile);

  
  import MainCard from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Cards/MainCard.vue";
  Vue.component("main-card", MainCard);

  
  import TheHeaderScholarshipCard from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Cards/ScholarshipCompetition/TheHeaderScholarshipCard.vue";
  Vue.component("the-header-scholarship-card", TheHeaderScholarshipCard);

  
  import TheMainCardSchCompetition from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Cards/ScholarshipCompetition/TheMainCardSchCompetition.vue";
  Vue.component("the-main-card-sch-competition", TheMainCardSchCompetition);

  
  import TheScoresCompetitionCard from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Cards/ScholarshipCompetition/TheScoresCompetitionCard.vue";
  Vue.component("the-scores-competition-card", TheScoresCompetitionCard);

  
  import TitleCard from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Cards/TitleCard.vue";
  Vue.component("title-card", TitleCard);

  
  import DatePicker from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/DatePicker/DatePicker.vue";
  Vue.component("date-picker", DatePicker);

  
  import FormSettingAchievement from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Dialogs/FormSettingAchievement.vue";
  Vue.component("form-setting-achievement", FormSettingAchievement);

  
  import TheAchievementEditDialog from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Dialogs/TheAchievementEditDialog.vue";
  Vue.component("the-achievement-edit-dialog", TheAchievementEditDialog);

  
  import TheEditAvatarDialog from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Dialogs/TheEditAvatarDialog.vue";
  Vue.component("the-edit-avatar-dialog", TheEditAvatarDialog);

  
  import TheInformationCompetitionDialog from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Dialogs/TheInformationCompetitionDialog.vue";
  Vue.component("the-information-competition-dialog", TheInformationCompetitionDialog);

  
  import ErrorsAlert from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Errors/ErrorsAlert.vue";
  Vue.component("errors-alert", ErrorsAlert);

  
  import CriteriaAchievementTextField from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Forms/FormAchievement/CriteriaAchievementTextField.vue";
  Vue.component("criteria-achievement-text-field", CriteriaAchievementTextField);

  
  import TheAchievementFileInput from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Forms/FormAchievement/TheAchievementFileInput.vue";
  Vue.component("the-achievement-file-input", TheAchievementFileInput);

  
  import TheAchievementKindSelect from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Forms/FormAchievement/TheAchievementKindSelect.vue";
  Vue.component("the-achievement-kind-select", TheAchievementKindSelect);

  
  import TheFormFillingAchievements from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Forms/FormAchievement/TheFormFillingAchievements.vue";
  Vue.component("the-form-filling-achievements", TheFormFillingAchievements);

  
  import AchievementKindLevelTextField from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Forms/FormAdminAchievementKind/AchievementKindLevelTextField.vue";
  Vue.component("achievement-kind-level-text-field", AchievementKindLevelTextField);

  
  import AchievementKindUnitTextField from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Forms/FormAdminAchievementKind/AchievementKindUnitTextField.vue";
  Vue.component("achievement-kind-unit-text-field", AchievementKindUnitTextField);

  
  import SubunitLevelTextField from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Forms/FormAdminAchievementKind/SubunitLevelTextField.vue";
  Vue.component("subunit-level-text-field", SubunitLevelTextField);

  
  import SectionEditLevel from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Forms/SectionEditAchievement/SectionEditLevel.vue";
  Vue.component("section-edit-level", SectionEditLevel);

  
  import SectionEditSubunit from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Forms/SectionEditAchievement/SectionEditSubunit.vue";
  Vue.component("section-edit-subunit", SectionEditSubunit);

  
  import SectionEditUnit from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Forms/SectionEditAchievement/SectionEditUnit.vue";
  Vue.component("section-edit-unit", SectionEditUnit);

  
  import SectionEditAchievement from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Forms/SectionEditAchievement.vue";
  Vue.component("section-edit-achievement", SectionEditAchievement);

  
  import Upload from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Forms/Upload.vue";
  Vue.component("upload", Upload);

  
  import PastEducation from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Icons/PastEducation.vue";
  Vue.component("past-education", PastEducation);

  
  import Trophy from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Icons/Trophy.vue";
  Vue.component("trophy", Trophy);

  
  import UniversityIcon from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Icons/UniversityIcon.vue";
  Vue.component("university-icon", UniversityIcon);

  
  import AchievementListTab from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Tab/AchievementListTab.vue";
  Vue.component("achievement-list-tab", AchievementListTab);

  
  import FileListTab from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Tab/FileListTab.vue";
  Vue.component("file-list-tab", FileListTab);

  
  import PersonalInfoTab from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Tab/PersonalInfoTab.vue";
  Vue.component("personal-info-tab", PersonalInfoTab);

  
  import RatingTab from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Tab/RatingTab.vue";
  Vue.component("rating-tab", RatingTab);

  
  import TheScholarshipCompetitionTab from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Tab/TheScholarshipCompetitionTab.vue";
  Vue.component("the-scholarship-competition-tab", TheScholarshipCompetitionTab);

  
  import TheAchievementTableForStatementScholarship from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/Tables/TheAchievementTableForStatementScholarship.vue";
  Vue.component("the-achievement-table-for-statement-scholarship", TheAchievementTableForStatementScholarship);

  
  import TuningModule from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/TuningModule.vue";
  Vue.component("tuning-module", TuningModule);

  
  import Portfolio from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/portfolio/portfolio.vue";
  Vue.component("portfolio", Portfolio);

  
  import MainInfo from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/programms/components/MainInfo.vue";
  Vue.component("main-info", MainInfo);

  
  import StructSpo from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/programms/components/struct_spo.vue";
  Vue.component("struct-spo", StructSpo);

  
  import CreateRpd from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/programms/rpd/create_rpd.vue";
  Vue.component("create-rpd", CreateRpd);

  
  import DepartmentAgreedRpd from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/programms/rpd/department_agreed_rpd.vue";
  Vue.component("department-agreed-rpd", DepartmentAgreedRpd);

  
  import EditRpd from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/programms/rpd/edit_rpd.vue";
  Vue.component("edit-rpd", EditRpd);

  
  import IndexRpd from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/programms/rpd/index_rpd.vue";
  Vue.component("index-rpd", IndexRpd);

  
  import LibraryAgreedRpd from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/programms/rpd/library_agreed_rpd.vue";
  Vue.component("library-agreed-rpd", LibraryAgreedRpd);

  
  import ReportRpd from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/programms/rpd/report_rpd.vue";
  Vue.component("report-rpd", ReportRpd);

  
  import ShowRpd from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/programms/rpd/show_rpd.vue";
  Vue.component("show-rpd", ShowRpd);

  
  import SoftwareAgreedRpd from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/programms/rpd/software_agreed_rpd.vue";
  Vue.component("software-agreed-rpd", SoftwareAgreedRpd);

  
  import UmuAgreedRpd from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/programms/rpd/umu_agreed_rpd.vue";
  Vue.component("umu-agreed-rpd", UmuAgreedRpd);

  
  import CreateRpg from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/programms/rpg/create_rpg.vue";
  Vue.component("create-rpg", CreateRpg);

  
  import EditRpg from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/programms/rpg/edit_rpg.vue";
  Vue.component("edit-rpg", EditRpg);

  
  import IndexRpg from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/programms/rpg/index_rpg.vue";
  Vue.component("index-rpg", IndexRpg);

  
  import ShowRpg from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/programms/rpg/show_rpg.vue";
  Vue.component("show-rpg", ShowRpg);

  
  import CreateRpp from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/programms/rpp/create_rpp.vue";
  Vue.component("create-rpp", CreateRpp);

  
  import EditRpp from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/programms/rpp/edit_rpp.vue";
  Vue.component("edit-rpp", EditRpp);

  
  import IndexRpp from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/programms/rpp/index_rpp.vue";
  Vue.component("index-rpp", IndexRpp);

  
  import ShowRpp from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/programms/rpp/show_rpp.vue";
  Vue.component("show-rpp", ShowRpp);

  
  import IndexQuestionnaire from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/questionnaire/index_questionnaire.vue";
  Vue.component("index-questionnaire", IndexQuestionnaire);

  
  import QuestionnaireAttempt from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/questionnaire/questionnaire_attempt.vue";
  Vue.component("questionnaire-attempt", QuestionnaireAttempt);

  
  import QuestionnaireResult from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/questionnaire/questionnaire_result.vue";
  Vue.component("questionnaire-result", QuestionnaireResult);

  
  import QuestionnaireResultBySpec from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/questionnaire/questionnaire_result_by_spec.vue";
  Vue.component("questionnaire-result-by-spec", QuestionnaireResultBySpec);

  
  import StudyYear from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/record_book/study_year.vue";
  Vue.component("study-year", StudyYear);

  
  import RecordBookView from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/record_book_view.vue";
  Vue.component("record-book-view", RecordBookView);

  
  import AmsuScholarshipCard from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/scholarship/Cards/AmsuScholarshipCard.vue";
  Vue.component("amsu-scholarship-card", AmsuScholarshipCard);

  
  import MeetingScholarshipAchievementCard from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/scholarship/Cards/Meeting/MeetingScholarshipAchievementCard.vue";
  Vue.component("meeting-scholarship-achievement-card", MeetingScholarshipAchievementCard);

  
  import MeetingVoteCommentCard from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/scholarship/Cards/Meeting/MeetingVoteCommentCard.vue";
  Vue.component("meeting-vote-comment-card", MeetingVoteCommentCard);

  
  import TheMeetingScholarshipHeaderCard from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/scholarship/Cards/Meeting/TheMeetingScholarshipHeaderCard.vue";
  Vue.component("the-meeting-scholarship-header-card", TheMeetingScholarshipHeaderCard);

  
  import TheMeetingScholarshipParameterCard from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/scholarship/Cards/Meeting/TheMeetingScholarshipParameterCard.vue";
  Vue.component("the-meeting-scholarship-parameter-card", TheMeetingScholarshipParameterCard);

  
  import TheMeetingScholarshipStatementsCard from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/scholarship/Cards/Meeting/TheMeetingScholarshipStatementsCard.vue";
  Vue.component("the-meeting-scholarship-statements-card", TheMeetingScholarshipStatementsCard);

  
  import TheMeetingSectionParamsMeeting from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/scholarship/Cards/Meeting/TheMeetingSectionParamsMeeting.vue";
  Vue.component("the-meeting-section-params-meeting", TheMeetingSectionParamsMeeting);

  
  import TheMeetingStatementAchievementTypeCard from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/scholarship/Cards/Meeting/TheMeetingStatementAchievementTypeCard.vue";
  Vue.component("the-meeting-statement-achievement-type-card", TheMeetingStatementAchievementTypeCard);

  
  import TheMeetingVoteCommentAchTypeCard from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/scholarship/Cards/Meeting/TheMeetingVoteCommentAchTypeCard.vue";
  Vue.component("the-meeting-vote-comment-ach-type-card", TheMeetingVoteCommentAchTypeCard);

  
  import ThePastStatementCard from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/scholarship/Cards/Meeting/ThePastStatementCard.vue";
  Vue.component("the-past-statement-card", ThePastStatementCard);

  
  import ThePastStatementExpansionPanelContent from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/scholarship/Cards/Meeting/ThePastStatementExpansionPanelContent.vue";
  Vue.component("the-past-statement-expansion-panel-content", ThePastStatementExpansionPanelContent);

  
  import TheStatementCardAllComment from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/scholarship/Cards/Meeting/TheStatementCardAllComment.vue";
  Vue.component("the-statement-card-all-comment", TheStatementCardAllComment);

  
  import TheStudentScholarshipCommentsCard from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/scholarship/Cards/Student/TheStudentScholarshipCommentsCard.vue";
  Vue.component("the-student-scholarship-comments-card", TheStudentScholarshipCommentsCard);

  
  import TheStudentScholarshipHeaderCard from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/scholarship/Cards/Student/TheStudentScholarshipHeaderCard.vue";
  Vue.component("the-student-scholarship-header-card", TheStudentScholarshipHeaderCard);

  
  import TheStudentScholarshipRatingCard from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/scholarship/Cards/Student/TheStudentScholarshipRatingCard.vue";
  Vue.component("the-student-scholarship-rating-card", TheStudentScholarshipRatingCard);

  
  import TheStudentScholarshipScoreCard from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/scholarship/Cards/Student/TheStudentScholarshipScoreCard.vue";
  Vue.component("the-student-scholarship-score-card", TheStudentScholarshipScoreCard);

  
  import TheMeetingScholarshipContainer from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/scholarship/Container/TheMeetingScholarshipContainer.vue";
  Vue.component("the-meeting-scholarship-container", TheMeetingScholarshipContainer);

  
  import TheStudentScholarshipContainer from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/scholarship/Container/TheStudentScholarshipContainer.vue";
  Vue.component("the-student-scholarship-container", TheStudentScholarshipContainer);

  
  import DocumentViewerSection from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/scholarship/Dialogs/AchievementStatementDialog/DocumentViewerSection.vue";
  Vue.component("document-viewer-section", DocumentViewerSection);

  
  import ParamAchievementSection from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/scholarship/Dialogs/AchievementStatementDialog/ParamAchievementSection.vue";
  Vue.component("param-achievement-section", ParamAchievementSection);

  
  import TheMeetingBasicInformationDialog from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/scholarship/Dialogs/Meeting/Information/TheMeetingBasicInformationDialog.vue";
  Vue.component("the-meeting-basic-information-dialog", TheMeetingBasicInformationDialog);

  
  import TheMeetingParameterInformationDialog from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/scholarship/Dialogs/Meeting/Information/TheMeetingParameterInformationDialog.vue";
  Vue.component("the-meeting-parameter-information-dialog", TheMeetingParameterInformationDialog);

  
  import TheMeetingRecordBookStudent from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/scholarship/Dialogs/Meeting/Information/TheMeetingRecordBookStudent.vue";
  Vue.component("the-meeting-record-book-student", TheMeetingRecordBookStudent);

  
  import TheMeetingStatementInformationDialog from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/scholarship/Dialogs/Meeting/Information/TheMeetingStatementInformationDialog.vue";
  Vue.component("the-meeting-statement-information-dialog", TheMeetingStatementInformationDialog);

  
  import TheEditAchievementTypeStatementDialog from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/scholarship/Dialogs/Meeting/TheEditAchievementTypeStatementDialog.vue";
  Vue.component("the-edit-achievement-type-statement-dialog", TheEditAchievementTypeStatementDialog);

  
  import TheMeetingAchievementsStatementDialog from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/scholarship/Dialogs/Meeting/TheMeetingAchievementsStatementDialog.vue";
  Vue.component("the-meeting-achievements-statement-dialog", TheMeetingAchievementsStatementDialog);

  
  import TheMeetingCommentForStatementDialog from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/scholarship/Dialogs/Meeting/TheMeetingCommentForStatementDialog.vue";
  Vue.component("the-meeting-comment-for-statement-dialog", TheMeetingCommentForStatementDialog);

  
  import TheMeetingEditAchievementParametersDialog from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/scholarship/Dialogs/Meeting/TheMeetingEditAchievementParametersDialog.vue";
  Vue.component("the-meeting-edit-achievement-parameters-dialog", TheMeetingEditAchievementParametersDialog);

  
  import TheMeetingEditParamsDialog from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/scholarship/Dialogs/Meeting/TheMeetingEditParamsDialog.vue";
  Vue.component("the-meeting-edit-params-dialog", TheMeetingEditParamsDialog);

  
  import TheMeetingShowAchievementDialog from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/scholarship/Dialogs/Meeting/TheMeetingShowAchievementDialog.vue";
  Vue.component("the-meeting-show-achievement-dialog", TheMeetingShowAchievementDialog);

  
  import TheMeetingShowStatementDialog from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/scholarship/Dialogs/Meeting/TheMeetingShowStatementDialog.vue";
  Vue.component("the-meeting-show-statement-dialog", TheMeetingShowStatementDialog);

  
  import TheMeetingVotingDialog from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/scholarship/Dialogs/Meeting/TheMeetingVotingDialog.vue";
  Vue.component("the-meeting-voting-dialog", TheMeetingVotingDialog);

  
  import ScholarshipSideDialog from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/scholarship/Dialogs/ScholarshipSideDialog.vue";
  Vue.component("scholarship-side-dialog", ScholarshipSideDialog);

  
  import TheStudentShowStatementDialog from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/scholarship/Dialogs/Student/TheStudentShowStatementDialog.vue";
  Vue.component("the-student-show-statement-dialog", TheStudentShowStatementDialog);

  
  import TheMeetingDatePicker from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/scholarship/Form/DatePicker/TheMeetingDatePicker.vue";
  Vue.component("the-meeting-date-picker", TheMeetingDatePicker);

  
  import TheMeetingScholarshipParameterForm from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/scholarship/Form/TheMeetingScholarshipParameterForm.vue";
  Vue.component("the-meeting-scholarship-parameter-form", TheMeetingScholarshipParameterForm);

  
  import IncreasedScholarship from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/scholarship/IncreasedScholarship.vue";
  Vue.component("increased-scholarship", IncreasedScholarship);

  
  import MeetingVotesInformationList from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/scholarship/Lists/MeetingVotesInformationList.vue";
  Vue.component("meeting-votes-information-list", MeetingVotesInformationList);

  
  import TheMeetingVoteCommentMenu from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/scholarship/Menu/TheMeetingVoteCommentMenu.vue";
  Vue.component("the-meeting-vote-comment-menu", TheMeetingVoteCommentMenu);

  
  import MeetingScholarshipStatementsTable from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/scholarship/Tables/Meeting/MeetingScholarshipStatementsTable.vue";
  Vue.component("meeting-scholarship-statements-table", MeetingScholarshipStatementsTable);

  
  import TheMeetingScholarshipAchievementsStatementTable from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/scholarship/Tables/Meeting/TheMeetingScholarshipAchievementsStatementTable.vue";
  Vue.component("the-meeting-scholarship-achievements-statement-table", TheMeetingScholarshipAchievementsStatementTable);

  
  import TheMeetingVotingTable from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/scholarship/Tables/Meeting/TheMeetingVotingTable.vue";
  Vue.component("the-meeting-voting-table", TheMeetingVotingTable);

  
  import TheStudentAchievementsStatementsTable from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/scholarship/Tables/Student/TheStudentAchievementsStatementsTable.vue";
  Vue.component("the-student-achievements-statements-table", TheStudentAchievementsStatementsTable);

  
  import TheStudentRatingTableStatements from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/scholarship/Tables/Student/TheStudentRatingTableStatements.vue";
  Vue.component("the-student-rating-table-statements", TheStudentRatingTableStatements);

  
  import StatementEdit from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/statement_edit.vue";
  Vue.component("statement-edit", StatementEdit);

  
  import CardDetailsPlaceHostel from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/statement_hostel/Cards/Commissions/CardDetailsPlaceHostel.vue";
  Vue.component("card-details-place-hostel", CardDetailsPlaceHostel);

  
  import CardDetailsStatement from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/statement_hostel/Cards/Commissions/CardDetailsStatement.vue";
  Vue.component("card-details-statement", CardDetailsStatement);

  
  import CardListApplicants from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/statement_hostel/Cards/Commissions/CardListApplicants.vue";
  Vue.component("card-list-applicants", CardListApplicants);

  
  import CardListDistributionPlaces from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/statement_hostel/Cards/Commissions/CardListDistributionPlaces.vue";
  Vue.component("card-list-distribution-places", CardListDistributionPlaces);

  
  import CardListStatements from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/statement_hostel/Cards/Commissions/CardListStatements.vue";
  Vue.component("card-list-statements", CardListStatements);

  
  import CardListStatementsV2 from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/statement_hostel/Cards/Commissions/CardListStatementsV2.vue";
  Vue.component("card-list-statements-v2", CardListStatementsV2);

  
  import CardPinning from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/statement_hostel/Cards/Commissions/CardPinning.vue";
  Vue.component("card-pinning", CardPinning);

  
  import CardStatisticsForDirectorCampus from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/statement_hostel/Cards/Commissions/CardStatisticsForDirectorCampus.vue";
  Vue.component("card-statistics-for-director-campus", CardStatisticsForDirectorCampus);

  
  import FormationHostelOrder from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/statement_hostel/Cards/Commissions/FormationHostelOrder.vue";
  Vue.component("formation-hostel-order", FormationHostelOrder);

  
  import CardCurrStatement from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/statement_hostel/Cards/Pichers/CardCurrStatement.vue";
  Vue.component("card-curr-statement", CardCurrStatement);

  
  import CardHostelPlace from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/statement_hostel/Cards/Pichers/CardHostelPlace.vue";
  Vue.component("card-hostel-place", CardHostelPlace);

  
  import CardLastStmHostel from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/statement_hostel/Cards/Pichers/CardLastStmHostel.vue";
  Vue.component("card-last-stm-hostel", CardLastStmHostel);

  
  import CardPersPerf from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/statement_hostel/Cards/Pichers/CardPersPerf.vue";
  Vue.component("card-pers-perf", CardPersPerf);

  
  import CardStatementComments from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/statement_hostel/Cards/Pichers/CardStatementComments.vue";
  Vue.component("card-statement-comments", CardStatementComments);

  
  import CardStatusesAllowance from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/statement_hostel/Cards/Pichers/CardStatusesAllowance.vue";
  Vue.component("card-statuses-allowance", CardStatusesAllowance);

  
  import CurrPlaceHostel from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/statement_hostel/Cards/Pichers/CurrPlaceHostel.vue";
  Vue.component("curr-place-hostel", CurrPlaceHostel);

  
  import StudRating from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/statement_hostel/Cards/Pichers/StudRating.vue";
  Vue.component("stud-rating", StudRating);

  
  import DialogContractHostel from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/statement_hostel/Dialogs/DialogContractHostel.vue";
  Vue.component("dialog-contract-hostel", DialogContractHostel);

  
  import DialogSubmitStatement from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/statement_hostel/Dialogs/DialogSubmitStatement.vue";
  Vue.component("dialog-submit-statement", DialogSubmitStatement);

  
  import FormSectionHostel from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/statement_hostel/Forms/FormSectionHostel.vue";
  Vue.component("form-section-hostel", FormSectionHostel);

  
  import AdminPanel from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/statement_hostel/Layouts/AdminPanel.vue";
  Vue.component("admin-panel", AdminPanel);

  
  import Dashboard from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/statement_hostel/Layouts/CommissionAppProcessing/Dashboard.vue";
  Vue.component("dashboard", Dashboard);

  
  import SelectFacultyPlaces from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/statement_hostel/Layouts/CommissionAppProcessing/SelectFacultyPlaces.vue";
  Vue.component("select-faculty-places", SelectFacultyPlaces);

  
  import ConfComm from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/statement_hostel/Layouts/ConfComm.vue";
  Vue.component("conf-comm", ConfComm);

  
  import ConfDirectorCampus from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/statement_hostel/Layouts/ConfDirectorCampus.vue";
  Vue.component("conf-director-campus", ConfDirectorCampus);

  
  import CardsFacultyPlaces from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/statement_hostel/Layouts/DistributionPlacesCampus/CardsFacultyPlaces.vue";
  Vue.component("cards-faculty-places", CardsFacultyPlaces);

  
  import CardsHostelStatuses from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/statement_hostel/Layouts/DistributionPlacesCampus/CardsHostelStatuses.vue";
  Vue.component("cards-hostel-statuses", CardsHostelStatuses);

  
  import DialogFacultyPlaces from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/statement_hostel/Layouts/DistributionPlacesCampus/DialogFacultyPlaces.vue";
  Vue.component("dialog-faculty-places", DialogFacultyPlaces);

  
  import Distribution from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/statement_hostel/Layouts/DistributionPlacesCampus/Distribution.vue";
  Vue.component("distribution", Distribution);

  
  import HostelStatement from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/statement_hostel/Layouts/HostelStatement.vue";
  Vue.component("hostel-statement", HostelStatement);

  
  import ListConfStatements from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/statement_hostel/Tabs/TabsInConfDeanExWork/ListConfStatements.vue";
  Vue.component("list-conf-statements", ListConfStatements);

  
  import WorkingWithOrders from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/statement_hostel/Tabs/TabsInConfDeanExWork/WorkingWithOrders.vue";
  Vue.component("working-with-orders", WorkingWithOrders);

  
  import ChoosePlace from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/statement_hostel/Tabs/TabsInStatement/ChoosePlace.vue";
  Vue.component("choose-place", ChoosePlace);

  
  import GeneralInfo from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/statement_hostel/Tabs/TabsInStatement/GeneralInfo.vue";
  Vue.component("general-info", GeneralInfo);

  
  import PersInfo from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/statement_hostel/Tabs/TabsInStatement/PersInfo.vue";
  Vue.component("pers-info", PersInfo);

  
  import TypeStatement from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/statement_hostel/Tabs/TabsInStatement/TypeStatement.vue";
  Vue.component("type-statement", TypeStatement);

  
  import CardAdditData from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/study/Cards/CardAdditData.vue";
  Vue.component("card-addit-data", CardAdditData);

  
  import CardAdditDataForElective from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/study/Cards/CardAdditDataForElective.vue";
  Vue.component("card-addit-data-for-elective", CardAdditDataForElective);

  
  import CardCommentsCommission from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/study/Cards/CardCommentsCommission.vue";
  Vue.component("card-comments-commission", CardCommentsCommission);

  
  import CardEstimation from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/study/Cards/CardEstimation.vue";
  Vue.component("card-estimation", CardEstimation);

  
  import CardEstimationMethodologist from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/study/Cards/CardEstimationMethodologist.vue";
  Vue.component("card-estimation-methodologist", CardEstimationMethodologist);

  
  import CardFillingTechnologicalMap from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/study/Cards/CardFillingTechnologicalMap.vue";
  Vue.component("card-filling-technological-map", CardFillingTechnologicalMap);

  
  import CardListTechMaps from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/study/Cards/CardListTechMaps.vue";
  Vue.component("card-list-tech-maps", CardListTechMaps);

  
  import CardParticipants from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/study/Cards/CardParticipants.vue";
  Vue.component("card-participants", CardParticipants);

  
  import CardStatusesCommission from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/study/Cards/CardStatusesCommission.vue";
  Vue.component("card-statuses-commission", CardStatusesCommission);

  
  import CardTableTechMap from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/study/Cards/CardTableTechMap.vue";
  Vue.component("card-table-tech-map", CardTableTechMap);

  
  import CardTableTechMapForCommission from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/study/Cards/CardTableTechMapForCommission.vue";
  Vue.component("card-table-tech-map-for-commission", CardTableTechMapForCommission);

  
  import CardViewingComment from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/study/Cards/CardViewingComment.vue";
  Vue.component("card-viewing-comment", CardViewingComment);

  
  import CardViewingCommentForMethologist from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/study/Cards/CardViewingCommentForMethologist.vue";
  Vue.component("card-viewing-comment-for-methologist", CardViewingCommentForMethologist);

  
  import DashboardConfirmCommissionEuk from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/study/DashboardConfirmCommissionEuk.vue";
  Vue.component("dashboard-confirm-commission-euk", DashboardConfirmCommissionEuk);

  
  import DashboardEstimationEuk from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/study/DashboardEstimationEuk.vue";
  Vue.component("dashboard-estimation-euk", DashboardEstimationEuk);

  
  import DialogEditEduHours from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/study/EditDialogs/DialogEditEduHours.vue";
  Vue.component("dialog-edit-edu-hours", DialogEditEduHours);

  
  import DialogEstimationTechMap from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/study/EditDialogs/DialogEstimationTechMap.vue";
  Vue.component("dialog-estimation-tech-map", DialogEstimationTechMap);

  
  import DialogInputElements from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/study/EditDialogs/DialogInputElements.vue";
  Vue.component("dialog-input-elements", DialogInputElements);

  
  import DialogSetComments from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/study/EditDialogs/DialogSetComments.vue";
  Vue.component("dialog-set-comments", DialogSetComments);

  
  import EditDialogFieldDataTable from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/study/EditDialogs/EditDialogFieldDataTable.vue";
  Vue.component("edit-dialog-field-data-table", EditDialogFieldDataTable);

  
  import NavDrawerSendingComment from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/study/NavDrawers/NavDrawerSendingComment.vue";
  Vue.component("nav-drawer-sending-comment", NavDrawerSendingComment);

  
  import TableListComments from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/study/Tables/TableListComments.vue";
  Vue.component("table-list-comments", TableListComments);

  
  import WhiteBook from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/study/white_book.vue";
  Vue.component("white-book", WhiteBook);

  
  import ExamIndex from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/timetable/exam_index.vue";
  Vue.component("exam-index", ExamIndex);

  
  import ExamShow from "/data/srv/cabinet.amursu.ru/releases/20250707100747/app/javascript/components/application/timetable/exam_show.vue";
  Vue.component("exam-show", ExamShow);
